module.exports = __webpack_public_path__ + "img/greenUp.5dedaada.svg";